// Signed-in user context
import React from "react";

export const user = {
  name: '',
  email: '',
}

export const UserContext = React.createContext({
  user :user,
  errors: [],
  sso_providers: [],
  companyCodeRequired: false,
  serverError: false,
  use_old_oauth_flow: false,
  old_oauth_flow_link: '',
  allow_username_password: false,
  checkUserEmail: (email, inOutlook, outlookToken, frontendUri = '' ) => {},
  login: (email, password, otp_attempt) => {},
  confirmCode: (confirmationCode, email, inOutlook) => {},
  loginSso: (sso_id) => {},
  signUp: (userValues) => {},
  forgotPassword: (email) => {},
  updatePassword: (password, confirmPassword, resetPasswordToken) => {},
  authenticate: (params) => {}
});
